export enum PartnersEnum {
	default = '',
	client = 'client',
	supplier = 'supplier',
}
